import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { AccountUserService } from '../../service/account.service';


@Injectable()
export class SharedSystemActivitiesService {

    activityAPI = "";
    user: any;
    httpClient: any;
    constructor(private http: HttpClient, private accountUserService: AccountUserService) {
      this.accountUserService.user.subscribe(x => this.user = x);
      this.activityAPI = environment.activity;
    }
  
   

    getSystemGeneratedActivityFeeds(organizationId, refObjectId, refObjectRecordId) {
      return this.http.get<any>(this.activityAPI + "/LionO360/2.0/API/ActivityFeed?organizationId="+organizationId+"&$filter=ObjectId eq "+refObjectId+" and ObjectRecordId eq "+ refObjectRecordId)
    }
}